export default __webpack_public_path__ + "static/career@1x-71d4fa8432ee3a42dac5ba39443d48d1.webp";